import { render, staticRenderFns } from "./ListUserKYC.vue?vue&type=template&id=246fefda"
import script from "./ListUserKYC.vue?vue&type=script&lang=js"
export * from "./ListUserKYC.vue?vue&type=script&lang=js"
import style0 from "./ListUserKYC.vue?vue&type=style&index=0&id=246fefda&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports